import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import {nanoid} from 'nanoid'


export const getNewMapData = () => {
  const blankMapData = get(window, 'webbymaps.data.blankMapData')
  const newMapData = cloneDeep(blankMapData)
  const newMarker = getNewMarker()
  newMapData.config.markers.push(newMarker)
  return newMapData
}

export const getNewMarker = () => {
  const blankMarker = get(window, 'webbymaps.data.blankMarker')
  const newMarker = cloneDeep(blankMarker)
  newMarker.id = nanoid()
  return newMarker
}